import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkResponseDto } from '../../../store/landscapeAPI/link/dto/response/link-response.dto';
import LandscapeIndicatorBaseTemplate from '../../../templates/LandscapeIndicatorBaseTemplate';
import { Button, Label } from '../../atoms';
import { LandscapeIndicatorExternalResourcesOrganism } from '../../organisms';
import BaseTemplate from '../BaseTemplate';

import styles from './LandscapeIndicatorExternalResourcesTemplate.module.css';

export interface LandscapeIndicatorExternalResourcesTemplateProps {
  data: LinkResponseDto[];
  handleDeleteLink: (id: string) => void;
  handleUpdateLink: (resourceId: string) => void;
}

const LandscapeIndicatorExternalResourcesTemplate: FC<
  LandscapeIndicatorExternalResourcesTemplateProps
> = ({ data, handleDeleteLink, handleUpdateLink }) => {
  const navigate = useNavigate();
  const { id, landscapeIndicatorId } = useParams();

  return (
    <BaseTemplate>
      <LandscapeIndicatorBaseTemplate>
        <div className={styles.heading}>
          <Label content="" size="lg" />
          <Button
            variant="dark"
            onClick={() =>
              navigate(
                `/landscapes/edit/${id}/indicators/edit/${landscapeIndicatorId}/external-resources/add`
              )
            }
          >
            Add Resource
          </Button>
        </div>
        <LandscapeIndicatorExternalResourcesOrganism
          data={data}
          handleDeleteLink={handleDeleteLink}
          handleUpdateLink={handleUpdateLink}
        />
      </LandscapeIndicatorBaseTemplate>
    </BaseTemplate>
  );
};

export default LandscapeIndicatorExternalResourcesTemplate;
